export default {
    nREListOfMeasurementPoints:'ListOfMeasurementPoints',
    nrepanelManagement:'PanelManagement',
    nreassociateDynamicModels:'AssociateDynamicModels',
    nredynamicModelManagement:'DynamicModelManagement',
    nremeasurementPointPanelManagement:'MeasurementPointPanelManagement',
    nreequipmentDynamicManagement:'EquipmentDynamicManagement',
    nreassociativeMeasurementPoints:'AssociativeMeasurementPoints',
    nredeviceMeasurement:'DeviceAssociationsList',
    nredynamicEffectList:'DynamicEffectList',
    nreDeviceList:'DeviceList',

}